import { z } from 'zod';
import { areaViewSchema } from './IAreaView';
import { fullMergedTagSchema } from './IMergedTag';
import { mergedEquipmentSchema } from './IMergedEquipment';
import { floorViewSchema } from './IFloorView';
import { dateField } from '../schemas/common.schemas';

// Schemas (source of truth)
export const fullAreaViewDataSchema = areaViewSchema.extend({
	tags: z.array(fullMergedTagSchema),
	equipments: z.array(mergedEquipmentSchema),
});

export const fullMergedFloorViewDataSchema = floorViewSchema.omit({ areas: true }).extend({
	tags: z.array(fullMergedTagSchema),
	areas: z.array(fullAreaViewDataSchema),
});

export const fullMergedFloorViewDataWithTimeSchema = fullMergedFloorViewDataSchema.extend({
	timestamp: dateField,
});

// Types (derived from schemas)
export type IMergedTagWithProfession = z.infer<typeof fullMergedTagSchema>;
export type IFullAreaViewData = z.infer<typeof fullAreaViewDataSchema>;
export type IFullMergedFloorViewData = z.infer<typeof fullMergedFloorViewDataSchema>;
export type IFullMergedFloorViewDataWithTime = z.infer<typeof fullMergedFloorViewDataWithTimeSchema>;
